export class TaskListAuthenModel {
  constructor () {
    this.redirectUrl = '';
  }

  getData (dataSource) {
    if (dataSource && Object.prototype.hasOwnProperty.call(dataSource, 'redirectUrl')) {
      this.redirectUrl = dataSource.redirectUrl;
    }

    return this;
  }
}